(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["care"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-care-toc]').forEach(function(toc) {
      var carePage = toc.closest('.care-page');
      var links = toc.querySelectorAll('a[data-section]');
      var sections = carePage ? carePage.querySelectorAll('[data-care-section]') : [];

      if (!links.length || !sections.length || typeof IntersectionObserver === 'undefined') return;

      function setActive(id) {
        links.forEach(function(link) {
          var isActive = link.getAttribute('data-section') === id;
          link.classList.toggle('active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      if (window.location.hash) {
        setActive(window.location.hash.slice(1));
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      }, { rootMargin: '-10% 0px -80% 0px', threshold: 0 });

      sections.forEach(function(section) {
        observer.observe(section);
      });

      links.forEach(function(link) {
        link.addEventListener('click', function(event) {
          if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) return;

          var target = document.getElementById(link.getAttribute('data-section'));
          if (!target) return;

          event.preventDefault();

          if (window.location.hash !== link.hash) {
            history.pushState(null, '', link.hash);
          }

          var behavior = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          target.scrollIntoView({ behavior: behavior, block: 'start' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Updates the cart in place via the Section Rendering API: one
  // /cart/change.js request returns the cart JSON plus this section
  // re-rendered, which replaces the section wrapper's content. Listeners
  // are delegated at the document level (scoped by [data-line] so they
  // never catch the PDP stepper) and therefore survive the DOM swap.
  (function() {
    var inFlight = false;
    var cartWarnTimers = {};

    function showCartLineWarn(line, stock) {
      var warn = document.querySelector('[data-stock-warn-line="' + line + '"]');
      if (!warn) return;
      var textEl = warn.querySelector('.stock-warn__text');
      if (textEl) textEl.textContent = warn.dataset.textTpl.replace('COUNT', stock);
      warn.classList.add('stock-warn--visible');
      warn.removeAttribute('aria-hidden');
      clearTimeout(cartWarnTimers[line]);
      cartWarnTimers[line] = setTimeout(function() { dismissCartLineWarn(line); }, 3500);
    }

    function dismissCartLineWarn(line) {
      var warn = document.querySelector('[data-stock-warn-line="' + line + '"]');
      if (!warn) return;
      warn.classList.remove('stock-warn--visible');
      warn.setAttribute('aria-hidden', 'true');
      clearTimeout(cartWarnTimers[line]);
    }

    function updateCartMaxedState() {
      document.querySelectorAll('.qty-stepper__btn[data-action="plus"][data-max]').forEach(function(btn) {
        if (!btn.dataset.line) return;
        var max = parseInt(btn.dataset.max, 10);
        var input = document.querySelector('.qty-stepper__input[data-line="' + btn.dataset.line + '"]');
        if (!input) return;
        btn.classList.toggle('qty-stepper__btn--maxed', (parseInt(input.value, 10) || 0) >= max);
      });
    }

    function updateCart(line, qty) {
      var root = document.querySelector('[data-cart-section-id]');
      if (!root || inFlight) return;
      inFlight = true;
      var sectionId = root.dataset.cartSectionId;
      root.querySelectorAll('.qty-stepper__btn[data-line], .qty-stepper__input[data-line]')
        .forEach(function(el) { el.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: sectionId })
      }).then(function(r) {
        if (!r.ok) throw new Error();
        return r.json();
      }).then(function(cart) {
        var wrapper = document.getElementById('shopify-section-' + sectionId);
        var html = cart.sections && cart.sections[sectionId];
        if (wrapper && html) {
          var prevFill = wrapper.querySelector('.shipping-threshold__fill');
          var prevProgress = prevFill
            ? prevFill.style.getPropertyValue('--progress').trim()
            : null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sectionId);
          wrapper.innerHTML = fresh ? fresh.innerHTML : html;
          if (prevProgress !== null) {
            var nextFill = wrapper.querySelector('.shipping-threshold__fill');
            if (nextFill) {
              var targetProgress = nextFill.style.getPropertyValue('--progress').trim();
              nextFill.style.setProperty('--progress', prevProgress);
              void nextFill.offsetWidth;
              nextFill.style.setProperty('--progress', targetProgress);
            }
          }
        }
        var badge = document.querySelector('.cart-badge');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('cart-badge--hidden', cart.item_count === 0);
        }
        inFlight = false;
        updateCartMaxedState();
      }).catch(function() {
        window.location.reload();
      });
    }

    document.addEventListener('click', function(e) {
      var remove = e.target.closest('.cart-line__remove[data-line]');
      if (remove) {
        e.preventDefault();
        updateCart(parseInt(remove.dataset.line, 10), 0);
        return;
      }
      var btn = e.target.closest('.qty-stepper__btn[data-line]');
      if (!btn || btn.disabled) return;
      var line = parseInt(btn.dataset.line, 10);
      var input = document.querySelector('.qty-stepper__input[data-line="' + line + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      if (btn.dataset.action === 'minus') {
        val = Math.max(0, val - 1);
        dismissCartLineWarn(line);
      } else {
        var maxQty = btn.dataset.max ? parseInt(btn.dataset.max, 10) : null;
        if (maxQty !== null && val >= maxQty) {
          showCartLineWarn(line, maxQty);
          return;
        }
        val = val + 1;
      }
      input.value = val;
      updateCart(line, val);
    });

    document.addEventListener('change', function(e) {
      var input = e.target.closest('.qty-stepper__input[data-line]');
      if (!input) return;
      var val = Math.max(0, parseInt(input.value, 10) || 0);
      updateCart(parseInt(input.dataset.line, 10), val);
    });

    updateCartMaxedState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  (function() {
    var btn = document.getElementById('contact-send-another');
    if (btn) btn.addEventListener('click', function() { window.location.reload(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var menuToggle = document.getElementById('menu-toggle');
    var menu = document.getElementById('mobile-menu');
    var scrim = document.getElementById('mobile-menu-scrim');
    var closeBtn = document.getElementById('mobile-menu-close');
    var searchToggle = document.getElementById('search-toggle');
    var searchOverlay = document.getElementById('search-overlay');
    var searchBackdrop = document.getElementById('search-overlay-backdrop');
    var searchClose = document.getElementById('search-overlay-close');
    var searchInput = document.getElementById('search-overlay-input');

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function() {
        if (menu.classList.contains('is-open')) closeMenu();
        else openMenu();
      });
    }
    if (scrim) scrim.addEventListener('click', closeMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    function openSearch() {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (searchInput) searchInput.focus();
      }, 50);
    }
    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', openSearch);
    }
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
        else if (menu && menu.classList.contains('is-open')) closeMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies"]) return;
  try {
    
  (function() {
    var tocLinks = document.querySelectorAll('#policies-toc a[data-section]');
    var articles = document.querySelectorAll('.policy-section[id]');
    if (!tocLinks.length || !articles.length || typeof IntersectionObserver === 'undefined') return;

    var activeId = null;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          activeId = entry.target.id;
          tocLinks.forEach(function(link) {
            link.classList.toggle('active', '#' + activeId === link.getAttribute('href'));
          });
        }
      });
    }, { rootMargin: '-10% 0px -80% 0px', threshold: 0 });

    articles.forEach(function(a) { observer.observe(a); });

    tocLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(link.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var form = document.getElementById('pdp-form');
    var variantInput = document.getElementById('variant-id');
    var priceEl = document.getElementById('pdp-price');
    var addBtn = document.getElementById('pdp-add-btn');
    var inventoryEl = document.getElementById('pdp-inventory');
    var inventoryText = document.getElementById('pdp-inventory-text');
    var mainImg = document.getElementById('pdp-main-img');
    var qtyInput = document.getElementById('pdp-qty');
    var qtyMinus = document.querySelector('.pdp__qty-wrap [data-action="minus"]');
    var qtyPlus = document.querySelector('.pdp__qty-wrap [data-action="plus"]');

    var pdpStockWarnEl = document.getElementById('pdp-stock-warn');
    var currentStock = null;
    var stockEnforced = false;
    var stockWarnTimer = null;
    var cartQtyMap = {};
    var inCartQty = 0;

    function hidePdpWarn() {
      if (pdpStockWarnEl) {
        pdpStockWarnEl.classList.remove('stock-warn--visible');
        pdpStockWarnEl.setAttribute('aria-hidden', 'true');
      }
      clearTimeout(stockWarnTimer);
    }

    function showPdpWarn(useCartMsg) {
      if (!pdpStockWarnEl || currentStock === null) return;
      var textEl = pdpStockWarnEl.querySelector('.stock-warn__text');
      if (textEl) {
        var tpl = (useCartMsg && pdpStockWarnEl.dataset.cartTextTpl)
          ? pdpStockWarnEl.dataset.cartTextTpl
          : pdpStockWarnEl.dataset.textTpl;
        textEl.textContent = tpl.replace('COUNT', currentStock);
      }
      pdpStockWarnEl.classList.add('stock-warn--visible');
      pdpStockWarnEl.removeAttribute('aria-hidden');
      clearTimeout(stockWarnTimer);
      stockWarnTimer = setTimeout(hidePdpWarn, 3500);
    }

    function updatePdpQtyMaxed() {
      if (!qtyPlus) return;
      var v = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      qtyPlus.classList.toggle('qty-stepper__btn--maxed', stockEnforced && currentStock !== null && v + inCartQty >= currentStock);
    }

    var galleryJsonEl = document.getElementById('pdp-gallery-json');
    var galleryImages = galleryJsonEl ? JSON.parse(galleryJsonEl.textContent) : [];
    var pdpIdx = 0;

    function fireLightbox() {
      document.dispatchEvent(new CustomEvent('pdp:open-lightbox', { detail: { index: pdpIdx } }));
    }

    document.addEventListener('pdp:lightbox-navigate', function(e) {
      var idx = e.detail.index;
      pdpIdx = idx;
      var img = galleryImages[idx];
      if (img && mainImg) {
        mainImg.srcset = '';
        mainImg.src = img.src;
        mainImg.alt = img.alt || '';
      }
      document.querySelectorAll('.pdp__thumb').forEach(function(b) {
        b.classList.toggle('pdp__thumb--active', parseInt(b.dataset.index, 10) === idx);
      });
    });

    var galleryMain = document.getElementById('pdp-main-media');
    if (galleryMain) {
      galleryMain.addEventListener('click', fireLightbox);
      galleryMain.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fireLightbox(); }
      });
    }

    var variantsEl = document.getElementById('product-json');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) { cartQtyMap[item.variant_id] = item.quantity; });
        var vid = parseInt(variantInput.value, 10);
        if (vid) { inCartQty = cartQtyMap[vid] || 0; updatePdpQtyMaxed(); }
      })
      .catch(function() {});

    var optionCount = document.querySelectorAll('.pdp__selector').length;
    var paymentWrap = document.getElementById('pdp-payment');

    var selectedOptions = {};
    document.querySelectorAll('.swatch--active').forEach(function(btn) {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
    });

    document.querySelectorAll('.swatch').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.dataset.optionIndex;
        var val = btn.dataset.value;
        selectedOptions[idx] = val;
        applyGroupFilter();
        document.querySelectorAll('.swatch[data-option-index="' + idx + '"]').forEach(function(b) {
          b.classList.remove('swatch--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('swatch--active');
        btn.setAttribute('aria-pressed', 'true');
        var labelEl = document.getElementById('option-value-' + idx);
        if (labelEl) labelEl.textContent = val;
        updateVariant();
      });
    });

    function updateVariant() {
      // Resolve a variant only once every option has an explicit choice;
      // a partial match would silently fall back to the first variant.
      if (Object.keys(selectedOptions).length < optionCount) return;
      var match = optionCount === 0
        ? variants[0]
        : variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return selectedOptions[i] === opt;
            });
          });
      if (!match) return;
      if (qtyInput) qtyInput.value = 1;

      variantInput.value = match.id;
      if (paymentWrap) paymentWrap.hidden = false;

      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="pdp__price-compare">' + match.compare_at_price_formatted + '</span> ';
        }
        html += match.price_formatted;
        priceEl.innerHTML = html;
      }

      var available = match.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelOos;
      }

      var qty = match.inventory_quantity;
      if (inventoryEl && qty !== undefined) {
        inventoryEl.hidden = false;
        inventoryEl.className = 'pdp__inventory';
        var text = '';
        if (qty <= 0) {
          inventoryEl.classList.add('pdp__inventory--oos');
          text = inventoryEl.dataset.textOos;
        } else if (qty <= 5) {
          inventoryEl.classList.add('pdp__inventory--low');
          text = inventoryEl.dataset.textLowTpl.replace('COUNT', qty);
        } else {
          inventoryEl.classList.add('pdp__inventory--healthy');
          text = inventoryEl.dataset.textInStock;
        }
        if (inventoryText) inventoryText.textContent = text;
      }

      if (match.featured_image && mainImg) {
        mainImg.srcset = '';
        mainImg.src = match.featured_image.src;
        mainImg.alt = match.featured_image.alt || '';
        var varImgId = match.featured_image.id;
        var newIdx = galleryImages.findIndex(function(img) { return img.id === varImgId; });
        if (newIdx !== -1) {
          pdpIdx = newIdx;
          document.querySelectorAll('.pdp__thumb').forEach(function(b) {
            b.classList.toggle('pdp__thumb--active', parseInt(b.dataset.index, 10) === newIdx);
          });
        }
      }

      if (match.inventory_management && match.inventory_policy === 'deny') {
        currentStock = match.inventory_quantity;
        stockEnforced = true;
      } else {
        currentStock = null;
        stockEnforced = false;
      }
      inCartQty = cartQtyMap[match.id] || 0;
      hidePdpWarn();
      updatePdpQtyMaxed();

      try { history.replaceState({}, '', '?variant=' + match.id); } catch(e) {}
    }

    document.querySelectorAll('.pdp__thumb').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.pdp__thumb').forEach(function(b) { b.classList.remove('pdp__thumb--active'); });
        btn.classList.add('pdp__thumb--active');
        pdpIdx = parseInt(btn.dataset.index, 10) || 0;
        if (mainImg) {
          mainImg.srcset = '';
          mainImg.src = btn.dataset.src;
          mainImg.alt = btn.dataset.alt || '';
        }
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
        hidePdpWarn();
        updatePdpQtyMaxed();
      });
      qtyPlus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10);
        if (stockEnforced && currentStock !== null && v + inCartQty >= currentStock) {
          showPdpWarn(inCartQty > 0);
          return;
        }
        qtyInput.value = v + 1;
        updatePdpQtyMaxed();
      });
    }

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var id = variantInput.value;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!id) return;
        if (stockEnforced && currentStock !== null && qty + inCartQty > currentStock) {
          showPdpWarn(inCartQty > 0);
          return;
        }
        addBtn.disabled = true;
        var prev = addBtn.textContent;
        addBtn.textContent = addBtn.dataset.labelAdding;
        var formData = new FormData(form);
        formData.set('id', id);
        formData.set('quantity', String(qty));
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(formData)
        }).then(function(r) {
          if (!r.ok) {
            return r.json().then(function(data) { throw new Error(data.description || addBtn.dataset.labelError); });
          }
          return r.json();
        }).then(function() {
          var vid = parseInt(id, 10);
          cartQtyMap[vid] = (cartQtyMap[vid] || 0) + qty;
          inCartQty = cartQtyMap[vid];
          updatePdpQtyMaxed();
          // The badge is rendered server-side with the cart count, so the
          // new total is the current text plus what was just added — no
          // extra /cart.js round trip needed.
          var badge = document.querySelector('.cart-badge');
          if (badge) {
            badge.textContent = (parseInt(badge.textContent, 10) || 0) + qty;
            badge.classList.remove('cart-badge--hidden');
            badge.classList.remove('cart-badge--bump');
            void badge.offsetWidth;
            badge.classList.add('cart-badge--bump');
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          addBtn.textContent = addBtn.dataset.labelAdded;
          setTimeout(function() {
            addBtn.textContent = prev;
            addBtn.disabled = false;
          }, 1600);
        }).catch(function(err) {
          addBtn.textContent = err.message || prev;
          setTimeout(function() {
            addBtn.textContent = prev;
            addBtn.disabled = false;
          }, 2400);
        });
      });
    }

    // Returns true if thumbnail's group doesn't match any selected swatch
    // Shared images (empty group) and an empty section never hide
    function shouldHide(group, chosen) {
      if (group === '') return false;
      if (chosen.length === 0) return false;
      return chosen.indexOf(group) === -1;
    }

    // Builds a lowercase list of selected swatch values, then hides every thumbnail whose data-group doesn't match one of them
    function applyGroupFilter() {
      let chosen = Object.keys(selectedOptions).map(function(k) {
        return selectedOptions[k].toLowerCase();
      });
      document.querySelectorAll('.pdp__thumb').forEach(function(b) {
        b.hidden = shouldHide(b.dataset.group, chosen);
      });
    }

    applyGroupFilter()
    updateVariant();
  })();

  } catch(e) { console.error(e); }
})();
})();
